<template>
  <div class="animated fadeIn">
    <div class="text-center mt-5 pt-5">
      <b-spinner style="width: 3rem; height: 3rem;" label="Large Spinner"></b-spinner>
      <h2>Aguarde!</h2>
      <small>Verificando suas credenciais...</small>
    </div>
  </div>
</template>

<script>
import { JWTService } from '@/shared/services/jwt'
import { mapActions } from 'vuex'
import SignInMixin from '@/store/module/signIn/mixin'
import PermissionMixin from '@/store/module/permission/mixin'
import { globalActions as authActions } from '@/store/module/auth/actionTypes'
import { globalActions as permissionActions } from '@/store/module/permission/actionTypes'
import { loading, toast } from '@/shared/utils/UIHelper'
import PCIRepository from '@/shared/http/repositories/pci/pci'
import roles from '@/shared/utils/roles'
import { actionTypes as CompanyActions } from '@/store/module/company/actions'
import CompanyMixin from '@/store/module/company/mixin'
import { zdocsDocumentosUrl, abrirZDocsEmNovaAba } from '@/shared/utils/zdocs'

export default {
  name: 'AuthSSO',
  mixins: [SignInMixin, PermissionMixin, CompanyMixin],
  computed: {
    token: function () {
      var result = null
      if (this.$router.currentRoute.params.token !== undefined) {
        result = this.$router.currentRoute.params.token
      }
      return result
    },
    screen: function () {
      var result = ''
      if (this.$router.currentRoute.params.screen !== undefined) {
        result = this.$router.currentRoute.params.screen
      }
      return result
    },
    company: function () {
      var result = 1
      if (this.$router.currentRoute.query.company !== undefined) {
        result = this.$router.currentRoute.query.company
      }
      return result
    }
  },
  mounted () {
    JWTService.DestroyToken()
    setTimeout(() => this.onValidateSSO(), 1000)
  },
  methods: {
    // PCI pelo ZSistemas. Com ?contrato=&obra= (referencias) abre a planilha do contrato, todos os
    // tipos, so com a obra; sem eles cai na lista. Tudo na MESMA aba: a aba do zcloud aberta pelo
    // Delphi nao tem outro uso, e o `origem=sso` faz a lista abrir a planilha aqui tambem.
    abrirPci () {
      const lista = { name: 'PciSheets', query: { origem: 'sso' } }
      const { contrato, obra } = this.$router.currentRoute.query
      if (!contrato || !obra || !this.hasRole(roles.RW_OPER_PCI)) {
        this.$router.push(lista)
        return
      }
      // `this.company` aqui e o computed do ?company= (codigoZ), que sombreia o getter do CompanyMixin;
      // a empresa carregada pelo GET_COMPANY_BY_CODIGO esta no getter da store.
      const empresa = this.$store.getters['company/company']
      PCIRepository.ResolverSSO(empresa && empresa.id, contrato, obra)
        .then(response => {
          if (response.data.code <= 0) throw new Error(response.data.message)
          const { pciIds, obraId, referenciaObra } = response.data.data
          const paramId = 'pciid-' + Math.random().toString(36).substr(2, 16)
          window.localStorage.setItem(paramId, JSON.stringify(pciIds))
          this.$router.push({ name: 'PCI', query: { paramId, obraId, obraRef: referenciaObra } })
        })
        .catch(err => {
          toast.error(err.message || this.$lang.Common.CouldNotLoadRegister)
          this.$router.push(lista)
        })
    },
    ...mapActions({
      signSSO: authActions.SIGN_SSO,
      fetchUserInfo: authActions.FETCH_USER_INFO
    }),
    onValidateSSO () {
      if (this.token) {
        loading.push()
        var data = {
          'token': this.token
        }
        this.signSSO(data)
          .then((response) => {
            this.fetchUserInfo()
              .then(() => {
                this.$store.dispatch(permissionActions.GET_ALL_PERMISSIONS)
                  .then(() => {
                  })
                  .then(() => {
                    this[CompanyActions.GET_COMPANY_BY_CODIGO](this.company)
                      .then(() => {
                        this.$nextTick(() => {
                          if (this.screen && this.screen.toUpperCase() === 'ZDOCS' && this.hasRole(roles.RW_OPER_DOCUMENTS)) {
                            // ZDocs standalone em outra aba e esta vai pra pagina inicial; se o navegador
                            // bloquear a aba, a StartPage oferece o botao. Sem ZDocsURL cai no GED interno.
                            const url = zdocsDocumentosUrl(this.company && this.company.id)
                            if (url) {
                              abrirZDocsEmNovaAba(url)
                              this.$router.push({ name: 'StartPage' })
                            } else this.$router.push({ name: 'GED' })
                          } else if (this.screen && this.screen.toUpperCase() === 'ZPAGDD' /* this.hasRole() */) {
                            // ZPAGDD ia pra DespesasDiversos (/financeiro/despesas/diversos,
                            // miscellaneousexpenses.vue) enquanto o menu Z Pag aponta pra
                            // ReemmbolsoDiversos (/despesa/diversos, miscellaneousreimbursement.vue).
                            // Quem entrava pelo ZPag caia na tela antiga; o menu e a boa.
                            this.$router.push({ name: 'ReemmbolsoDiversos' })
                          } else if (this.screen && this.screen.toUpperCase() === 'ZPAGRD' /* this.hasRole() */) {
                            this.$router.push({ name: 'RembolsoDespesas' })
                          } else if (this.screen && this.screen.toUpperCase() === 'ZPAGDV' /* this.hasRole() */) {
                            this.$router.push({ name: 'viagemdespesa' })
                          } else if (this.screen && this.screen.toUpperCase() === 'PRESTCONTA' /* this.hasRole() */) {
                            this.$router.push({ name: 'prestacaoconta' })
                          } else if (this.screen && this.screen.toUpperCase() === 'APROVACAO') {
                            this.$router.push({ name: 'PdrBonusApproval' })
                          } else if (this.screen && this.screen.toUpperCase() === 'PCI') {
                            this.abrirPci()
                          } else if (this.screen && this.screen.toUpperCase() === 'OCORRENCIA') {
                            this.$router.push({ name: 'ListaDeChamado' })
                          } else {
                            this.$router.push({ name: 'StartPage' })
                          }
                        })
                      })
                  })
              })
              .finally(() => loading.close())
          })
          .catch((err) => {
            console.log(err)
            loading.close()
            this.$router.push({ name: 'SignIn' })
          })
      } else {
        this.$router.push({ name: 'SignIn' })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/public/sso/authsso.vue